// frontend/src/components/report/primitives/ReportCard.js

// Common card chrome, replacing the "rounded-2xl border bg-card p-5
// shadow-sm sm:p-6" + h2-icon-title + description paragraph pattern that was
// copy-pasted at every card site in the old ReportPage.js. `variant="accent"`
// reproduces the darker header-block style used for the wide-report/plan and
// technical-SEO-issues cards.
//
// The "plain" variant's heading uses the brand mark's own blue→teal→green
// gradient (.brand-gradient-text, index.css) instead of plain foreground
// text, and a matching gradient hairline caps the card — one consistent,
// on-brand device repeated at every section so each new section reads as a
// clear break while scrolling, instead of leaning on a generic card shadow.
export function ReportCard({ icon, title, description, variant = "plain", children }) {
  if (variant === "accent") {
    return (
      <div className="mt-8 overflow-hidden rounded-2xl border border-primary/30 bg-card shadow-sm">
        <div className="border-b bg-accent/40 p-5 sm:p-6">
          <h2 className="mb-1.5 flex items-center gap-1.5 font-heading text-lg font-semibold">
            {icon} {title}
          </h2>
          {description && <p className="text-base text-muted-foreground">{description}</p>}
        </div>
        <div className="space-y-5 p-5 sm:p-6">{children}</div>
      </div>
    );
  }
  return (
    <div className="mt-8 overflow-hidden rounded-2xl border bg-card shadow-sm">
      <div
        className="h-1"
        style={{ background: "linear-gradient(90deg, #2D7DFF 0%, #00C2C7 50%, #6BD54E 100%)" }}
        aria-hidden="true"
      />
      <div className="p-5 sm:p-6">
        <h2 className="mb-1.5 flex items-center gap-2 font-heading text-lg font-semibold">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            {icon}
          </span>
          <span className="brand-gradient-text">{title}</span>
        </h2>
        {description && <p className="mb-3 text-base text-muted-foreground">{description}</p>}
        {children}
      </div>
    </div>
  );
}
